import { SkeletonLoader } from '../../../../../../components/Loaders'

export const GrantsLoader = () => {
  return <SkeletonLoader count={6} innerContainerProps={{ md: 6 }} />
}
